import $ from 'jquery';
import popup from './popup';
import DEPART_DIC from '../constants/DepartDic';

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getSharedImageUrl() {
  const num = getRandomInt(1, 17);
  return `https://www.geograftour.com/static/img/share_images/share-${num}.jpg`;
}

export const getVKTourLink = (row) => {
  const { text } = getTourDescriptionForMessengerURL(row);
  return `https://vk.com/share.php?url=https://geograftour.com/tours/tour-info/${
    row.offer_id
  }/&title=${text}&description=${
    row.hoteldescription
  }&image=${getSharedImageUrl()}&utm_source=share2`;
};

export function getTourDescriptionForMessengerURL(row) {
  let depart_from = row.depart_id ? row.depart_id : row.departurecode;
  const imageUrl = encodeURIComponent(`${row.hotel_image_src}`);
  const text = encodeURIComponent(`
*${row.hotel_name} ${row.star_id}⭐️*
${row.country_name}, ${row.town_name}, из ${DEPART_DIC[depart_from].name_from}
${row.dt1} ${row.nights} ночей
${row.price} ${row.currency_class} за номер
Туристы: 
${row.adult} взрослых
${
  row.child
    ? row.child == 1
      ? row.child + ' ребенок'
      : +row.child + ' детей'
    : ''
}

Подробнее здесь:
https://www.geograftour.com/tours/tour-info/${row.offer_id}
`);

  return { imageUrl, text };
}

export const getWhatsAppTourLink = (row) => {
  const { text } = getTourDescriptionForMessengerURL(row);
  return `https://api.whatsapp.com/send?text=${text}`;
};

export const getTelegramTourLink = (row) => {
  const { imageUrl, text } = getTourDescriptionForMessengerURL(row);
  return `https://telegram.me/share/url?url=%20&text=${imageUrl}${text}`;
};

export const getFacebookTourLink = (row) => {
  return `https://www.facebook.com/sharer/sharer.php?u=https://www.geograftour.com/tours/tour-info/${row.offer_id}`;
};
export const getViberTourLink = (row) => {
  const { imageUrl, text } = getTourDescriptionForMessengerURL(row);
  return `viber://forward?text=${imageUrl}${text}`;
};

export const getHotelReviews = (e, hotelId) => {
  console.log(e, hotelId);
  e.preventDefault();
  e.stopPropagation();
  $.getJSON(
    'https://www.geograftour.com/tourvisor/api/?method=hotel&reviews=1&hotelcode=' +
      hotelId,
    function (res) {
      const { hotel } = res.data;
      const hotelReviewsTemplate = `<div class="hotel-detail">
            <h2 style="margin-bottom: 20px">
                <span>Отзывы об отеле ${hotel.name} ${hotel.stars}*</span>
                <span class="country">${hotel.country}, ${hotel.region}</span>
            </h2>
            <div class="tab__content-wrapper" data-tab-item="reviews">
                <div class="tour__reviews" style="display: flex; flex-direction: column; gap: 20px ">
                    ${
                      hotel.reviewscount && hotel.reviews
                        ? hotel.reviews.review
                            .map(
                              (review) => `
                    <div class="review__item">
                        <div class="item__header">
                            <p class="item__name">
                                <b>${
                                  review.name ? review.name : 'Анонимный отзыв'
                                }</b>
                                <div>
                                ${Array.from(
                                  { length: review.rate },
                                  () =>
                                    '<span><i class="fa fa-star"></i></span>'
                                ).join('')}
                                </div>
                            </p>
                            <p class="item__date">${review.reviewdate}</p>
                        </div>
                        <p class="item__content"">Плюсы: ${review.positive}</p>
                        <p class="item__content"">Минусы: ${review.negative}</p>
                        <p class="item__content""> ${review.content}</p>
                    </div>`
                            )
                            .join('')
                        : '<p class="review__empty">Еще никто не оставил отзыв</p>'
                    }

                </div>
            </div>
        </div>`;
      popup(hotelReviewsTemplate);
    }
  );
  return false;
};

export const getHotelMap = (e, hotelId) => {
  e.preventDefault();
  e.stopPropagation();
  const gt = window.gt || {};
  if (gt.getHotelMap) {
    gt.getHotelMap(hotelId);
  }
  return;
};
